import type { RootState } from "state/Reducers/rootReducer";

export const getUserInput = (state: RootState) => state.State.searchInput;

export const getSearchResult = (state: RootState) => state.State.searchResult;

export const getKeyWordsData = (state: RootState) => state.State.KeyWords;

export const getWebSitesData = (state: RootState) => state.State.WebSites;

export const getUserSelectedInputKeyWord = (state: RootState) =>
  state.State.userSelectedInputKeyWord;
// export const getClickedItem = (state: RootState) => state.State.clickedItem;

export const selectNavigation = (s: RootState) => s.navigation;
export const selectNavItems = (s: RootState) => s.navigation.navItems;
export const selectNavLoading = (s: RootState) => s.navigation.loading;
export const selectNavError = (s: RootState) => s.navigation.error;

export const selectImageSlice = (s: RootState) => s.image;
export const selectImages = (s: RootState) => s.image.imageItems;
export const selectImagesLoading = (s: RootState) => s.image.loading;
export const selectImagesError = (s: RootState) => s.image.error;

export const selectBannerImageSlice = (s: RootState) =>
  s.bannerImage.bannerImage;
export const selectBannerImage = (s: RootState) => s.bannerImage.bannerImage;
export const selectBannerImageLoading = (s: RootState) => s.bannerImage.loading;
export const selectBannerImageError = (s: RootState) => s.bannerImage.error;

export const selectFooterSectionImagesSlice = (s: RootState) =>
  s.footerSectionImages;
export const selectFooterSectionImages = (s: RootState) =>
  s.footerSectionImages.footerSectionImages;
export const selectFooterSectionImagesLoading = (s: RootState) =>
  s.footerSectionImages.loading;
export const selectFooterSectionImagesError = (s: RootState) =>
  s.footerSectionImages.error;

export const selectRecentlyUpdatedFilesSlice = (s: RootState) =>
  s.recentlyUpdatedFiles;
export const selectRecentlyUpdatedFiles = (s: RootState) =>
  s.recentlyUpdatedFiles.recentlyUpdatedFiles;
export const selectRecentlyUpdatedFilesLoading = (s: RootState) =>
  s.recentlyUpdatedFiles.loading;
export const selectRecentlyUpdatedFilesError = (s: RootState) =>
  s.recentlyUpdatedFiles.error;

export const selectRecentlyUpdatedPagesSlice = (s: RootState) =>
  s.recentlyUpdatedFiles;
export const selectRecentlyUpdatedPages = (s: RootState) =>
  s.recentlyUpdatedPages.recentlyUpdatedPages;
export const selectRecentlyUpdatedPagesLoading = (s: RootState) =>
  s.recentlyUpdatedPages.loading;
export const selectRecentlyUpdatedPagesError = (s: RootState) =>
  s.recentlyUpdatedPages.error;

export const selectQuickLinksSlice = (s: RootState) => s.quickLinks;
export const selectQuickLinks = (s: RootState) => s.quickLinks.quickLinksItems;
export const selectQuickLinksLoading = (s: RootState) => s.quickLinks.loading;
export const selectQuickLinksError = (s: RootState) => s.quickLinks.error;

export const selectResourceLinksSlice = (s: RootState) => s.resourceLinks;
export const selectResourceLinks = (s: RootState) =>
  s.resourceLinks.resourceLinksItems;
export const selectResourceLinksLoading = (s: RootState) =>
  s.resourceLinks.loading;
export const selectResourceLinksError = (s: RootState) => s.resourceLinks.error;

export const selectCurrentNewsSlice = (s: RootState) => s.currentNews;
export const selectCurrentNews = (s: RootState) => s.currentNews.currentNews;
export const selectCurrentNewsLoading = (s: RootState) => s.currentNews.loading;
export const selectCurrentNewsError = (s: RootState) => s.currentNews.error;

export const selectTitleTextsSlice = (s: RootState) => s.titleTexts;
export const selectTitleTexts = (s: RootState) => s.titleTexts.titleTexts;
export const selectTitleTextsLoading = (s: RootState) => s.titleTexts.loading;
export const selectTitleTextsError = (s: RootState) => s.titleTexts.error;

export const selectSpEnvironment = (s: RootState) => s.spEnvironment.spEnvironment;
